import script from "./onboardingTutorialsEmbed.vue?vue&type=script&lang=ts&setup=true"
export * from "./onboardingTutorialsEmbed.vue?vue&type=script&lang=ts&setup=true"

import "./onboardingTutorialsEmbed.vue?vue&type=style&index=0&id=e9502226&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9502226"]])

export default __exports__